export const getFirstDayOfMonth = (): string => {
  const currentDate = new Date();
  const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1, 0, 0, 0, 0);
  return firstDay.toISOString().split('T')[0];
};

export const getLastDayOfMonth = (): string => {
  const currentDate = new Date();
  const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0, 0, 0, 0, 0);
  return lastDay.toISOString().split('T')[0];
};

export const getToday = (): string => {
  return new Date().toISOString().split('T')[0];
};

export const getDayFromWeekBefore = (): string => {
  var date = new Date();
  date.setDate(date.getDate() - 7);

  return date.toISOString().split('T')[0];
}

export const formatDateToBR = (isoDate: string|undefined|null): string => {
  if (!isoDate) {
    return "N/A";
  }

  if (String(isoDate).trim().length === 10) {
    isoDate = `${isoDate} 00:00:00`;
  }

  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const twoPlaceUint = (value: number): string => {
  if (value >= 10) return String(value)
  if (value <= 0) return "00"

  return `0${value}`
}

export const formatDatetimeToBR = (isoDate: string|undefined|null): string => {
  if (!isoDate) {
    return "N/A";
  }

  if (String(isoDate).trim().length === 10) {
    isoDate = `${isoDate} 00:00:00`;
  }

  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  const hour = twoPlaceUint(date.getHours())
  const minute = twoPlaceUint(date.getMinutes())
  const second = twoPlaceUint(date.getSeconds())

  return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
};

export const removeHoursFromDate = (isoDate: string): string => {
  if (!isoDate) {
    return "N/A";
  }

  return isoDate.split('T')[0]
};
